import "./styles/App.css";
import React from "react";
import RoutesPath from "./component-layer/components/RoutesPath";
import {ContextProvider, useStateContext} from "./contextProvider";

function App() {
  return (
    <div>
      <ContextProvider>
        <RoutesPath />
      </ContextProvider>
    </div>
  );
}

export default App;
